<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" v-if="contacts.length">
				<span class="ml-2">فیلتر طرف حساب:</span>
				<v-btn-toggle v-model="contactFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="contact in contacts" :key="contact.id" :value="contact.id" small>
						{{ contact.businessName }}
						<v-badge color="blue" :content="contact.id === 0 ? items.filter(x => x.contact).length : `تعداد: ${items.filter(x => x.contact && x.contact.id == contact.id).length}, مجموع: ${String(items.filter(x => x.contact && x.contact.id == contact.id).reduce(function (a, b) { return a + b.share }, 0)).toPriceFormat()}` || '0'" inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :loading="loading" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td>
								{{ row.item.userLoanTitle }}
								<div class="grey--text">شماره وام: {{ row.item.userLoanCode }}</div>
							</td>
							<td class="text-center">
								{{ row.item.userLoanAmount.toString().toPriceFormat() }}
							</td>
							<td @click="manageLoans(row.item)" style="cursor: pointer;">
								{{ row.item.memberModel.fullName }}
								<div class="grey--text">کد ملی: {{ row.item.memberModel.nationalCode }}</div>
							</td>
							<td class="text-center">
								{{ row.item.contact.businessName }}
							</td>
							<td class="text-center">
								{{ row.item.dueDate_Persian.date }}
							</td>
							<td class="text-center">
								{{ row.item.share.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								<v-btn class="mx-2" dark small color="secondary" @click="edit(row.item)">
									<v-icon dark>
										mdi-credit-card
									</v-icon>
									ثبت واریزی
								</v-btn>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<div class="d-flex" style="position: absolute;bottom: 0;left: 0;
    left: 0;
		right: 0;
    font-size: 22px;
    background-color: rebeccapurple;
    color: #fff;
		justify-content: end;
    flex-wrap: wrap;">
			<div class="text-center px-3 py-3">
				مجموع: {{ sum.toString().toPriceFormat() }} تومان
			</div>
		</div>

		<v-dialog v-model="dialogTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-transaction v-if="dialogTransaction" :data="selectedTransaction" @callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import ModifyLoanPayment from '@/views/admin/ModifyLoanPayment.vue'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'ContactOverDue',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'modify-loan-payment': ModifyLoanPayment,
			'modify-transaction': () => import('@/views/admin/ModifyTransaction'),
			'manage-loan': () => import('@/views/admin/ManageLoan.vue'),
			'app-sms-detail': () => import('@/components/AppSmsDetails.vue'),
		},
		data() {
			return {
				selectedTransaction: null,
				dialogTransaction: false,
				dialogLoansManager: false,
				dialogModifyLoanPayment: false,
				selectedMember: {},
				selectedLoanPayment: null,
				errorMessages: '',
				search: '',
				loading: false,
				sum: 0,
				sumByDelays: 0,
				contactFilter: '',
				contacts: [],
				headers: [
					{
						text: 'مشخصات وام',
						align: 'start',
						sortable: true,
						value: 'userLoanTitle',
					}, {
						text: 'مبلغ وام',
						align: 'center',
						sortable: true,
						value: 'userLoanAmount',
					}, {
						text: 'مشخصات مشتری',
						align: 'start',
						sortable: true,
						value: 'memberModel.fullName',
					}, {
						text: 'کد ملی',
						align: 'center d-none',
						sortable: true,
						value: 'memberModel.nationalCode',
					}, {
						text: 'طرف حساب',
						align: 'center',
						sortable: true,
						value: 'contact.businessName',
					}, {
						text: 'سررسید واریز',
						align: 'center',
						sortable: true,
						value: 'dueDate_Persian',
						excel_value: 'dueDate_Persian.date',
					}, {
						text: 'سهم نماینده',
						align: 'center',
						sortable: true,
						value: 'share',
						width: 200
					}, {
						text: 'ثبت واریزی',
						align: 'center',
						sortable: false,
					}
				],
				items: [],
			}
		},
		computed: {
			excelFileName() {
				let name = 'لیست سررسید های طرف حساب ها'
				// if (this.startDate)
				// 	name += ' از ' + this.startDate.toString().split('T')[0]
				// if (this.endDate)
				// 	name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (!this.contactFilter)
					return this.items

				let clonedItems = []
				clonedItems.push(...this.items)

				clonedItems = clonedItems.filter(x => x.contact && x.contact.id == this.contactFilter)

				return clonedItems
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/UserLoan/ContactsOverDueList', {})
					.then(
						response => {
							this.items = response
							if (response.length)
								this.sum = response.map(x => x.share).reduce((prev, next) => {
									return prev + next
								})
							else
								this.sum = 0

							this.contacts = Object.values(
								response.reduce((acc, obj) => ({ ...acc, [obj.contact.id]: obj.contact }), {})
							)
							if (this.contacts.length) {
								this.contacts.push({ id: 0, businessName: 'همه' })
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			manageLoans(item) {
				this.selectedMember = { id: item.memberModel.id, fullName: item.memberModel.fullName, nationalCode: item.memberModel.nationalCode, mobile: item.memberModel.mobile }
				this.dialogLoansManager = true
			},
			edit(item) {
				this.selectedTransaction = { id: emptyId, paymentMethod: 2, isWithdraw: true, contact: { id: item.contact.id, businessName: item.contact.businessName, phone: item.contact.phone, fullName: item.contact.fullName }, userLoanContact: { id: item.id, title: `شماره وام: ${item.userLoanCode}, عنوان: ${item.userLoanTitle}`, code: item.userLoanCode }, amount: item.share }
				this.dialogTransaction = true
			},
			callbck_transaction(result) {
				this.dialogTransaction = false
				if (result)
					this.loadData()
			},
		},
	}
</script>
<style></style>
